import type { UserServerType, UserType } from '@/lib/types/user.types'

export const normalizeUser = (data: UserServerType): UserType => {
  return {
    id: data.id,
    username: data.username,
    email: data.email,
    phone: data.phone,
    createdAt: data.created_at,
    updatedAt: data.updated_at,
    admin: data.admin,
    lastActive: data.last_active,
    firstName: data.first_name,
    surname: data.surname,
    vatNo: data.vat_no,
    country: data.country,
    city: data.city,
    address: data.address,
    postcode: data.postcode,
    config: data.config,
    signUserAgreement: data.sign_user_agreement,
    revenueTierId: data.revenue_tier_id,
    recruitmentUtm: data.recruitment_utm,
    paymentBlocked: data.payment_blocked,
    tierPricingType: data.tier_pricing_type,
    tdAccountId: data.td_account_id,
    advertisers: data.stores.map((store) => ({
      id: store.id,
      name: store.feed_name,
      status: store.status,
      config: store.config,
      logoUrl: store.logo_url,
      stripeSubscriptionStatus: store.stripe_subscription_status,
      paymentType: store.payment_type,
    })),
    currencyObj: {
      code: data.currencyObj.code,
      name: data.currencyObj.name,
      symbol: data.currencyObj.symbol,
      subunit: data.currencyObj.subunit,
      isBefore: data.currencyObj.is_before,
      ratioToEur: data.currencyObj.ratio_to_eur,
    },
    lang: data.lang,
    ownPaymentsystem: data.own_paymentsystem,
    locale: data.locale,
    storeGroupId: data.store_group_id,
    isSuspended: data.is_suspended,
    isVerified: data.is_verified,
    subscriber: {
      id: data.subscriber?.id,
      hash: data.subscriber?.hash,
    },
  }
}
